module.exports = __webpack_public_path__ + "static/media/ftc.d4f3e386.svg";